import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "image-list" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "image-container" }
const _hoisted_5 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "header" }, [
      _createElementVNode("h1", null, "臻选礼诚")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cards, (card, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "image-item",
          onClick: ($event: any) => (_ctx.goToCardDetail(card.cardTypeId, card.cardName))
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              src: card.cardPicUrl,
              alt: card.cardName,
              class: "image"
            }, null, 8, _hoisted_5)
          ])
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "exchange-instructions" }, [
      _createElementVNode("h2", null, "兑换说明"),
      _createElementVNode("p", null, "1. 点击礼品券，可进入兑换页面。"),
      _createElementVNode("p", null, "2. 请在有效期内完成兑换。"),
      _createElementVNode("p", null, "2. 每个礼品券仅限使用一次。"),
      _createElementVNode("p", null, "3. 如有问题，请联系客服: 19941356990。")
    ], -1))
  ]))
}